import React, { ReactNode } from 'react'
import './Style/Card.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel, faSearch, faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { useFilter } from '../../Hooks/useFilterContext';
import ExportButton from './ExportButton';

interface ICardProps<T> {
    title?: string;
    children: ReactNode;
    options: {
        hasDivisor?: Boolean;
        hasFilter?: Boolean;
        exportOptions?: {
            data: T[];
            format: 'xlsx' | 'doc' | 'pdf' 
        };
        redirectOptions?: {
            redirectUrl: string;
        };
    }
}

const Card = <T extends Record<string, any>>({title, children, options}: ICardProps<T>) => {
    const {hasFilter, redirectOptions, hasDivisor, exportOptions} = options;
    const {setFilters} = useFilter();
    
    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFilters({ search: e.target.value });
    }

    return (
        <div className='card'>
            <section className="card-header">
                <h4 className="card-title">
                    {title}
                </h4>
                <div className='aditional-content'>
                    {hasFilter && 
                        <div className='filter-input'>
                            <FontAwesomeIcon icon={faSearch}></FontAwesomeIcon>
                            <input type="text" name="filter-order" id="filter-order" placeholder='Numero do Pedido, Status' onChange={handleSearchChange}/>
                        </div>
                    }
                    {exportOptions && 
                        <ExportButton data={exportOptions.data} filename='Produtos Bloqueados' format={exportOptions.format} />
                    }
                    {redirectOptions && 
                        <div className='redirect-button'>
                            <FontAwesomeIcon icon={faUpRightFromSquare} color='var(--dark)'></FontAwesomeIcon>
                        </div> 
                    }
                </div>
            </section>
            {hasDivisor && <hr className='divider'/>}
            <section className='card-content'>
                    { children }                
            </section>
        </div>
    )
}

export default Card